module.exports = __webpack_public_path__ + "img/1485816739.37a43258.jpg";